export const NotFound = () => {
    return (
      <div className="sectiondiv">
        This page was not found
      </div>
    )
}
